var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1618874235(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1005,
    height: 178,
    viewBox: "0 0 1005 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 145.43C71 145.43 71 155.116 186.315 111.41C246.053 88.7686 280.789 43.1215 353.352 43.3714C429.254 43.6329 449.21 105.489 522.934 95.5656C594.311 85.9581 559.531 20.9898 630.617 10.7501C726.446 -3.05364 707.226 108.352 806.134 111.41C915.312 114.786 1002 1.42969 1002 1.42969",
    stroke: "white",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.801 46.3233C123.207 56.2364 75 123.791 75 123.791V177.43H1003V34.2625C1003 34.2625 981.593 88.4971 931.811 102.917C851.31 126.234 825.21 26.6773 735.194 34.2625C691.301 37.9611 678.744 62.5511 634.342 63.023C570.106 63.7057 570.62 6.52268 506.372 6.42982C422.265 6.30825 464.498 92.3458 382.638 102.917C300.475 113.526 274.499 34.6862 192.801 46.3233Z",
    fill: "url(#paint0_linear_3941_5170)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 155.93C2 155.93 123.207 56.083 192.801 46.2005C274.499 34.5992 300.475 113.197 382.638 102.619C464.498 92.0813 422.265 6.30862 506.372 6.42982C570.62 6.52239 570.106 63.5293 634.342 62.8487C678.744 62.3783 691.301 37.864 735.194 34.1768C825.21 26.6149 851.31 125.865 931.811 102.619C981.593 88.2444 1003 34.1768 1003 34.1768",
    stroke: "#541C9C",
    strokeOpacity: 0.3,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3941_5170",
    x1: 539,
    y1: 6.42969,
    x2: 539,
    y2: 177.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F80ED",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F80ED",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1618874235);
export default __webpack_public_path__ + "static/media/Group 1618874235.212a9762934dde88bc358c046d631c86.svg";
export { ForwardRef as ReactComponent };